var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { getValidateNameFn } from 'utils/formValidator';
import styles from './teamsCreateModal.module.scss';
export class TeamsCreateModalView extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = TeamsCreateModalView.getInitialState();
    }
    getFormErrors() {
        const { formValues } = this.state;
        const formErrors = TeamsCreateModalView.getInitialState().formErrors;
        const errorMessage = getValidateNameFn({
            requiredOptions: { errorMessage: 'Team name is required' },
        })(formValues.name);
        if (errorMessage) {
            formErrors.name = errorMessage;
        }
        return formErrors;
    }
    updateFormErrors() {
        this.setState({ formErrors: this.getFormErrors() });
    }
    isFormValid() {
        const formErrors = this.getFormErrors();
        return !formErrors.name;
    }
    handleNameChange(e) {
        if (!e)
            return;
        this.setState({
            formValues: {
                name: e.target.value,
            },
        }, () => {
            this.updateFormErrors();
        });
    }
    handleSubmit(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (!this.isFormValid()) {
            return;
        }
        const { formValues } = this.state;
        const { createTeam, notificationAdd } = this.props;
        analytics.settingsTeamModalFormSubmitted({ teamName: formValues.name });
        createTeam(formValues)
            .then(() => {
            const notificationOptions = {
                title: 'Team created',
                text: `"${formValues.name}" team has been created`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            };
            notificationAdd(notificationOptions);
            this.handleClose();
        })
            .catch((e) => {
            const notificationOptions = {
                title: 'An error occurred',
                text: `An error occurred when trying to create the "${formValues.name}" team`,
                icon: 'i-exclamation',
                className: 'danger',
            };
            notificationAdd(notificationOptions);
            throw new Error('Team already exist');
        });
    }
    handleClose(refetchData = true) {
        this.setState(TeamsCreateModalView.getInitialState());
        this.props.onClose(refetchData);
    }
    render() {
        const { isOpen } = this.props;
        const { formValues, formErrors } = this.state;
        return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: () => this.handleClose(false), className: styles.root }, { children: [_jsx(ModalHead, { title: "Create team", onClose: () => this.handleClose(false) }), _jsxs("form", Object.assign({ onSubmit: this.handleSubmit }, { children: [_jsx(ModalBody, Object.assign({ className: styles.teamModalBody }, { children: _jsx(FieldText, { label: "Team name", required: true, placeholder: "Team name...", meta: { error: formErrors.name }, input: {
                                    name: 'teamName',
                                    value: formValues.name,
                                    onChange: this.handleNameChange,
                                    onBlur: this.updateFormErrors,
                                } }) })), _jsx(ModalFoot, { cancelOnClick: () => this.handleClose(false), cancelName: "Cancel", confirmOnClick: this.handleSubmit, confirmName: "Save", confirmProps: {
                                disabled: !this.isFormValid(),
                            } })] }))] })));
    }
}
TeamsCreateModalView.getInitialState = () => ({
    formErrors: { name: '' },
    formValues: { name: '' },
});
__decorate([
    boundMethod
], TeamsCreateModalView.prototype, "getFormErrors", null);
__decorate([
    boundMethod
], TeamsCreateModalView.prototype, "updateFormErrors", null);
__decorate([
    boundMethod
], TeamsCreateModalView.prototype, "handleNameChange", null);
__decorate([
    boundMethod
], TeamsCreateModalView.prototype, "handleSubmit", null);
__decorate([
    boundMethod
], TeamsCreateModalView.prototype, "handleClose", null);
